<app-header-content-footer *transloco="let t"
                           [headerTitle]="t('reward-details')">
  <app-sidenav-content content showBanner>
    <app-reward-details *ngIf="reward" content [reward]="reward"></app-reward-details>
  </app-sidenav-content>
</app-header-content-footer>
